import { microdistricts } from "@app/api/endpoints";
import AppApi from "@app/api/index";

export interface MicrodistrictType {
	id: number;
	title: string;
	areaId: number;
}

export interface CreateMicrodistrictType {
	title: string;
	areaId: number;
}

export default class MicrodistrictApi {
	constructor(private readonly api: AppApi) {}

	public create(dto: CreateMicrodistrictType) {
		return this.api.client.post<CreateMicrodistrictType, MicrodistrictType>(microdistricts.create(), dto);
	}

	public getAll(areaId: number) {
		return this.api.client.get<void, MicrodistrictType[]>(microdistricts.getAll(areaId));
	}

	public getById(id: number) {
		return this.api.client.get<number, MicrodistrictType>(microdistricts.getById(id));
	}

	public rename(data: { id: number; title: string }) {
		return this.api.client.put<{ id: number; title: string }, string>(microdistricts.rename(), data);
	}

	public delete(id: number) {
		return this.api.client.delete<string, string>(microdistricts.delete(id));
	}
}
